import { IKogIcon } from "@/main/@types/interfaceIcons";

export function CancelledIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 310.000000 289.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,289.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M160 2750 c-11 -11 -20 -30 -20 -42 0 -16 167 -189 605 -628 333
          -333 605 -610 605 -615 0 -5 -272 -282 -605 -615 -438 -439 -605 -612 -605
          -628 0 -28 34 -62 63 -62 16 0 185 163 627 605 333 333 609 605 615 605 6 0
          282 -272 615 -605 442 -442 611 -605 627 -605 29 0 63 34 63 62 0 16 -167 189
          -605 628 -333 333 -605 610 -605 615 0 5 272 282 605 615 438 439 605 612 605
          628 0 28 -34 62 -63 62 -16 0 -185 -163 -627 -605 -333 -333 -609 -605 -615
          -605 -6 0 -282 272 -615 605 -442 442 -611 605 -627 605 -13 0 -32 -9 -43 -20z"
				/>
			</g>
		</svg>
	);
}
